import { useQuery } from "react-query";
import { getSecurityByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetSecurityByRecordNumber = (caseNumber) => {
  return useQuery(
    ["GetSecurityByRecordNumber", caseNumber],
    () => getSecurityByRecordNumber(caseNumber),
    { refetchOnWindowFocus: false }
  );
};
